import { render, staticRenderFns } from "./center_settings.vue?vue&type=template&id=0de34f0e&scoped=true"
import script from "./center_settings.vue?vue&type=script&lang=js"
export * from "./center_settings.vue?vue&type=script&lang=js"
import style0 from "./center_settings.vue?vue&type=style&index=0&id=0de34f0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de34f0e",
  null
  
)

export default component.exports